@charset "UTF-8";

/* libs/shared/src/lib/ui/modal/modal.component.scss */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.modal.active {
  opacity: 1;
  visibility: visible;
}
.modal.active .modal-container {
  transform: scale(1) translateY(0);
  opacity: 1;
}
.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.modal-container {
  position: relative;
  background: var(--background-white, #ffffff);
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(0, 0, 0, 0.05);
  max-width: 90vw;
  max-height: 90vh;
  width: auto;
  min-width: 400px;
  overflow: hidden;
  transform: scale(0.95) translateY(20px);
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
@media (max-width: 768px) {
  .modal-container {
    min-width: 320px;
    max-width: 95vw;
    margin: 20px;
  }
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--background-border, #e5e7eb);
  background: var(--background-light, #f9fafb);
  position: relative;
  min-height: 50px;
}
.modal-header .modal-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary, #111827);
  line-height: 1.3;
  letter-spacing: -0.025em;
}
.modal-header .btn-clear {
  position: absolute;
  top: 7px;
  right: 20px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: var(--text-muted, #6b7280);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 18px;
}
.modal-header .btn-clear:hover {
  background: var(--error-red-light, #fee2e2);
  color: var(--error-red, #dc2626);
  transform: scale(1.05);
}
.modal-header .btn-clear:active {
  transform: scale(0.95);
}
.modal-header .btn-clear::before {
  content: "\d7";
  font-size: 24px;
  font-weight: 300;
  line-height: 1;
}
.modal-header .btn-clear.float-right {
  float: none;
  position: absolute;
}
.confirm-head {
  display: flex;
  align-items: flex-start;
  gap: 13px;
}
.confirm-head .confirm-ico {
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 9px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  background: var(--background-light, #f3f4f6);
  color: var(--primary-color, #557892);
  font-size: 17px;
}
.confirm-head .confirm-ico i {
  line-height: 1;
}
.confirm-head .confirm-ico.danger {
  background: var(--error-red-light, #fbe9e7);
  color: var(--error-red, #e23b2e);
}
.confirm-head .confirm-msg {
  margin: 9px 0 0;
  font-size: 13.5px;
  color: var(--text-muted, #6b7280);
  line-height: 1.5;
}
.modal-body {
  padding: 32px;
  max-height: 60vh;
  overflow-y: auto;
  color: var(--text-secondary, #374151);
  line-height: 1.6;
}
.modal-body .content {
  font-size: 16px;
}
.modal-body .content p {
  margin: 0 0 16px;
}
.modal-body .content p:last-child {
  margin-bottom: 0;
}
.modal-body .content h1,
.modal-body .content h2,
.modal-body .content h3,
.modal-body .content h4,
.modal-body .content h5,
.modal-body .content h6 {
  margin: 0 0 12px;
  color: var(--text-primary, #111827);
}
.modal-body .content ul,
.modal-body .content ol {
  margin: 0 0 16px;
  padding-left: 24px;
}
.modal-body .content li {
  margin-bottom: 8px;
}
.modal-body::-webkit-scrollbar {
  width: 6px;
}
.modal-body::-webkit-scrollbar-track {
  background: var(--background-lighter, #f3f4f6);
  border-radius: 3px;
}
.modal-body::-webkit-scrollbar-thumb {
  background: var(--text-muted, #d1d5db);
  border-radius: 3px;
}
.modal-body::-webkit-scrollbar-thumb:hover {
  background: var(--text-secondary, #557892);
}
.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 0 32px 28px;
  border-top: none;
  background: transparent;
}
.modal-footer .btn {
  font-size: 13px;
  font-weight: 400;
  border-radius: 7px;
  padding: 7px 14px;
  min-width: 0;
  border: 1px solid transparent;
  cursor: pointer;
  transition:
    background 0.12s,
    box-shadow 0.12s,
    border-color 0.12s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  text-decoration: none;
}
.modal-footer .btn i {
  font-size: 12px;
  line-height: 1;
}
.modal-footer .btn.btn-primary {
  background: var(--primary-color, #61778f);
  color: #fff;
  box-shadow: none;
}
.modal-footer .btn.btn-primary:hover {
  background: var(--primary-color-hover, #557892);
}
.modal-footer .btn.btn-link {
  background: #fff;
  color: var(--text-primary, #1f2937);
  border-color: var(--background-border, #e5e7eb);
}
.modal-footer .btn.btn-link:hover {
  background: var(--background-light, #f9fafb);
}
.modal-footer .btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px var(--primary-color-light, rgba(97, 119, 143, 0.2));
}
.dependency-modal-content {
  min-width: 500px;
  max-width: 700px;
}
@media (max-width: 768px) {
  .dependency-modal-content {
    min-width: 320px;
    max-width: 95vw;
  }
}
.dependency-alert {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background:
    linear-gradient(
      135deg,
      #fef3c7 0%,
      #fde68a 100%);
  border: 1px solid #f59e0b;
  border-radius: 12px;
  margin-bottom: 24px;
  position: relative;
  overflow: hidden;
}
.dependency-alert::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: #f59e0b;
}
.dependency-alert .warning-icon {
  font-size: 24px;
  flex-shrink: 0;
  margin-top: 2px;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}
.dependency-alert .alert-content {
  flex: 1;
}
.dependency-alert .alert-content .alert-title {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: #92400e;
  line-height: 1.3;
}
.dependency-alert .alert-content .alert-message {
  margin: 0;
  color: #78350f;
  font-size: 14px;
  line-height: 1.5;
}
.dependency-summary {
  margin-bottom: 28px;
}
.dependency-summary .summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 50px;
  background:
    linear-gradient(
      135deg,
      #f8fafc 0%,
      #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}
.dependency-summary .summary-header:hover {
  background:
    linear-gradient(
      135deg,
      #f1f5f9 0%,
      #e2e8f0 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
.dependency-summary .summary-header:active {
  transform: translateY(0);
}
.dependency-summary .summary-header .summary-text {
  font-size: 16px;
  font-weight: 500;
  color: #475569;
}
.dependency-summary .summary-header .summary-text .dependency-count {
  font-weight: 700;
  color: #dc2626;
  background: #fee2e2;
  padding: 2px 8px;
  border-radius: 6px;
  margin: 0 4px;
}
.dependency-summary .summary-header .toggle-icon {
  color: #64748b;
  font-size: 14px;
  transition: transform 0.2s ease;
  font-weight: bold;
}
.dependency-summary .dependency-details {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}
.dependency-summary .dependency-details.expanded {
  max-height: 500px;
  overflow-y: auto;
}
.dependency-card {
  margin-top: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s ease;
}
.dependency-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.dependency-card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background:
    linear-gradient(
      135deg,
      #f8fafc 0%,
      #f1f5f9 100%);
}
.dependency-card .card-header .card-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
}
.dependency-card .card-header .item-count {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
  background: #e5e7eb;
  padding: 4px 10px;
  border-radius: 12px;
}
.dependency-card .card-divider {
  height: 1px;
  background:
    linear-gradient(
      90deg,
      transparent 0%,
      #e5e7eb 50%,
      transparent 100%);
}
.dependency-card .dependency-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.dependency-card .dependency-list .dependency-item {
  padding: 14px 20px;
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.2s ease;
}
.dependency-card .dependency-list .dependency-item:last-child {
  border-bottom: none;
}
.dependency-card .dependency-list .dependency-item:hover {
  background: #f8fafc;
}
.dependency-card .dependency-list .dependency-item .dependency-link {
  color: #3b82f6;
  text-decoration: none;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
  transition: all 0.2s ease;
  position: relative;
}
.dependency-card .dependency-list .dependency-item .dependency-link:hover {
  color: #1d4ed8;
  text-decoration: underline;
}
.dependency-card .dependency-list .dependency-item .dependency-link:visited {
  color: #7c3aed;
}
.dependency-card .dependency-list .dependency-item .dependency-link::before {
  content: "\2192";
  margin-right: 8px;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}
.dependency-card .dependency-list .dependency-item .dependency-link:hover::before {
  opacity: 1;
}
.modal-actions {
  display: flex;
  justify-content: center;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
}
.modal-actions .btn {
  padding: 14px 32px;
  font-size: 15px;
  font-weight: 600;
  min-width: 140px;
  border-radius: 10px;
}
.modal-actions .btn.btn-primary {
  background:
    linear-gradient(
      135deg,
      #3b82f6 0%,
      #2563eb 100%);
  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.3);
}
.modal-actions .btn.btn-primary:hover {
  background:
    linear-gradient(
      135deg,
      #2563eb 0%,
      #1d4ed8 100%);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
  transform: translateY(-2px);
}
@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes overlayFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media (max-width: 640px) {
  .modal-container {
    margin: 16px;
    min-width: 280px;
  }
  .modal-header,
  .modal-body,
  .modal-footer {
    padding-left: 20px;
    padding-right: 20px;
  }
  .modal-header {
    padding-top: 20px;
    padding-bottom: 16px;
  }
  .modal-header .modal-title {
    font-size: 18px;
    padding-right: 40px;
  }
  .modal-footer {
    flex-direction: column-reverse;
    gap: 8px;
  }
  .modal-footer .btn {
    width: 100%;
    justify-content: center;
  }
  .dependency-summary .summary-header {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }
  .dependency-summary .summary-header .toggle-icon {
    margin-top: 4px;
  }
}
/*# sourceMappingURL=modal.component.css.map */
